<template>
  <transition name="fade">
    <div class="group-delete-popup" v-if="popupActive">
      <div class="group-delete-popup-inner">
        <div class="group-delete-popup-background" @click="switchPopupActive(false)"></div>
        <div class="group-delete-popup-container">
          <div class="group-delete-popup-title">グループ削除</div>
          <p class="group-delete-popup-content">
            本当にグループを削除してもよろしいでしょうか？<br>
            削除したデータは元に戻せません。
          </p>
          <div class="popup-button-area">
            <button class="delete-button" @click="clickDelete">削除</button>
            <button class="cancel-button" @click="clickCancel">キャンセル</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

export default {
  name: "group-deletePopup",
  props: ['popupActive'],
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
    switchPopupActive(val) {
      this.$emit("update:popupActive", val)
    },
    clickDelete() {
      this.$emit("clickDeleteButton")
      this.$emit("update:popupActive", false)
    },
    clickCancel() {
      this.$emit("update:popupActive", false)
    },
  },
  created() {
  }
}
</script>

<style lang="scss" scoped>

.close-icon {
  float: right;
  cursor: pointer;
}

.vs-button {
  padding: 4px 24px !important;
}

.group-delete-popup-background {
  width: 100%;
  background: rgba(0,0,0,.4);
  position: absolute;
  top: 0;
  height: 100%;
  z-index: 10;
  transition: all .25s ease;
  opacity: 1;
  border-radius: 8px;
}

.group-delete-popup-inner {
  left: 0;
  transition: all .2s;
  width: 100%;
  height: 100%;
  // position: fixed;
  top: 0;
  z-index: 20000;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
}

.group-delete-popup-container {
  position: absolute;
  top: 90px;
  background: white;
  color: #4A4A4A;
  z-index: 11;
  min-width: 200px;
  padding: 20px;
  max-width: calc(100% - 30px);
  max-height: calc(100% - 30px);
  border-radius: 6px;
  .group-delete-popup-content {
    font-size: 14px;
    margin-top: 20px;
    margin-bottom: 30px;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.popup-button-area {
  display: flex;
  justify-content: space-between;
  button {
    appearance: none;
    color: white;
    width: 146px;
    height: 33px;
    display: flex;
    border-radius: 6px;
    justify-content: center;
    align-items: center;
    transition: 0.3s;
    cursor: pointer;
  }
  .delete-button {
    background: rgba(235, 87, 87, 0.4);
    border: solid 1px #EB5757;
    color: white;
    &:hover {
      background: #EB5757;
    }
  }
  .cancel-button{
    background: white;
    border: solid 1px #C4C4C4;
    color: #C4C4C4;
    &:hover {
      background: #6f6f6f;
    }
  }
}


</style>
